import { SecurityQuestionsSetupClass } from '../../components/descope-security-questions-setup/SecurityQuestionsSetupClass';

export const vars = SecurityQuestionsSetupClass.cssVarList;

const securityQuestionsSetup = {
  [vars.hostWidth]: 'fit-content',
  _fullWidth: {
    [vars.hostWidth]: '100%',
  },
};

export default securityQuestionsSetup;
